import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import PacotesBox from '@/components/feature/PacotesBox';
import NossosFones from '@/components/feature/NossosFones';

const equipamentos = [
  {
    icon: 'ri-headphone-line',
    nome: 'Fones Sem Fio Profissionais',
    descricao:
      'Headphones com tecnologia RF de longa distância, bateria de 10 a 12 horas, LEDs coloridos por canal e controle individual de volume. Confortáveis para uso contínuo o dia todo.',
    specs: ['Alcance até 200 m indoor', 'Bateria 10–12h', 'LED colorido por canal', 'Volume individual', 'Higienizados entre eventos'],
  },
  {
    icon: 'ri-radio-line',
    nome: 'Transmissores de Alta Potência',
    descricao:
      'Transmissores FM digitais que cobrem toda a área do evento sem interferências. Cada transmissor corresponde a um canal — palestrante, idioma ou DJ diferente.',
    specs: ['Até 10 canais simultâneos', 'Cobertura até 500 m outdoor', 'Tecnologia FM digital', 'Instalação em 30 min', 'Backup incluso'],
  },
  {
    icon: 'ri-mic-line',
    nome: 'Microfones Sem Fio',
    descricao:
      'Microfones de lapela e handheld para palestrantes e intérpretes. Transmissão em tempo real com latência inferior a 5ms — imperceptível ao ouvido humano.',
    specs: ['Lapela + handheld', 'Latência < 5ms', '1 mic por canal', 'Alcance 100 m', 'Bateria de longa duração'],
  },
];

const tiposEvento = [
  { icon: 'ri-building-2-line', titulo: 'Eventos Corporativos', desc: 'Convenções, all-hands, lançamento de produtos, kick-off de vendas.' },
  { icon: 'ri-graduation-cap-line', titulo: 'Treinamentos e T&D', desc: 'Múltiplas turmas simultâneas no mesmo espaço. Até 10 trilhas paralelas.' },
  { icon: 'ri-global-line', titulo: 'Conferências Multilíngues', desc: 'Tradução simultânea sem cabine. Cada canal = um idioma.' },
  { icon: 'ri-music-line', titulo: 'Silent Disco', desc: 'Festas, casamentos e confraternizações com vários DJs simultâneos.' },
  { icon: 'ri-heart-line', titulo: 'Casamentos', desc: 'Pista de dança silenciosa. Sem limite de horário, sem barulho para vizinhos.' },
  { icon: 'ri-microscope-line', titulo: 'Congressos Científicos', desc: 'Múltiplas sessões simultâneas no mesmo pavilhão. Sem necessidade de salas separadas.' },
  { icon: 'ri-leaf-line', titulo: 'Meditação e Mindfulness', desc: 'Práticas guiadas em silêncio absoluto, sem ruído externo interferindo na concentração dos participantes.' },
  { icon: 'ri-heart-pulse-line', titulo: 'Aulas de Yoga', desc: 'Áudio individual para cada aluno, sem caixas de som compartilhadas incomodando outras turmas no mesmo espaço.' },
  { icon: 'ri-run-line', titulo: 'Spinning e Aulas Fitness', desc: 'Música e comandos do instrutor direto no fone de cada aluno, com som de alta qualidade mesmo em ambientes compartilhados.' },
  { icon: 'ri-book-open-line', titulo: 'Aulas e Workshops', desc: 'Várias turmas ou idiomas acontecendo ao mesmo tempo no mesmo salão, cada aluno ouvindo só o canal da sua aula.' },
  { icon: 'ri-landscape-line', titulo: 'Experiências Imersivas e Sensoriais', desc: 'Ativações de marca, instalações sensoriais e jornadas guiadas com áudio sincronizado em cada fone imersivo.' },
  { icon: 'ri-goblet-line', titulo: 'Degustações', desc: 'Harmonização guiada por áudio, com o sommelier ou chef narrando cada etapa direto no ouvido dos participantes.' },
  { icon: 'ri-route-line', titulo: 'Visitas Técnicas', desc: 'Tours guiados em fábricas, obras e instalações, com o guia narrando em tempo real sem precisar gritar ou parar o grupo.' },
];

const perguntas = [
  {
    q: 'O que está incluso no aluguel de fones sem fio?',
    a: 'O pacote completo de aluguel inclui fones profissionais higienizados, transmissores de áudio, microfones sem fio para palestrantes, montagem, desmontagem, suporte técnico presencial durante todo o evento e fones de reserva (10% a mais do contratado).',
  },
  {
    q: 'Qual o valor mínimo para alugar fones sem fio para eventos?',
    a: 'Atendemos eventos a partir de 20 fones. O custo varia conforme o número de fones, duração do evento, cidade e serviços adicionais. Preencha o formulário de contato ou ligue para (11) 91777-6227 para receber uma proposta personalizada sem compromisso.',
  },
  {
    q: 'Com quanto tempo de antecedência devo solicitar o aluguel?',
    a: 'Recomendamos 15 dias de antecedência para eventos de até 200 fones. Para eventos maiores, 30 dias. Atendemos demandas urgentes conforme disponibilidade.',
  },
  {
    q: 'A STIB atende fora de São Paulo?',
    a: 'Sim. A STIB realiza aluguel de fones sem fio em todo o Brasil: São Paulo, Rio de Janeiro, Brasília, Belo Horizonte, Curitiba, Porto Alegre, Recife, Fortaleza, Salvador e demais cidades. Em Recife, Rio de Janeiro e Campinas, equipamentos e profissionais já estão presentes na cidade.',
  },
  {
    q: 'Tem locação de fones sem fio com equipe em Recife, Rio de Janeiro e Campinas?',
    a: 'Sim. A STIB conta com equipamentos e profissionais presentes em Recife, Rio de Janeiro e Campinas, o que agiliza a entrega, a montagem e o suporte técnico presencial na locação de fones sem fio imersivos. Não há escritório físico nessas cidades; o orçamento é centralizado pelo WhatsApp (11) 91777-6227.',
  },
  {
    q: 'Quantos fones vocês têm disponíveis?',
    a: 'Mantemos estoque de mais de 5.000 fones profissionais. Para eventos maiores, trabalhamos com parceiros para garantir disponibilidade ilimitada.',
  },
  {
    q: 'Como faço para solicitar um orçamento para aluguel de fones sem fio?',
    a: 'Para receber um orçamento personalizado, preencha o formulário de contato em nosso site ou ligue para (11) 91777-6227. Informe o número de fones, tipo de evento, cidade e data desejada. Nossa equipe retorna com uma proposta detalhada em até 24 horas.',
  },
  {
    q: 'Como funciona a higienização dos fones entre eventos?',
    a: 'Todos os fones passam por protocolo rigoroso de higienização com produtos profissionais após cada uso. Oferecemos também capas descartáveis individuais para máxima higiene.',
  },  {
    q: 'Vocês alugam fones sem fio para aulas de yoga, meditação ou spinning?',
    a: 'Sim. Nossos fones sem fio imersivos são usados em aulas de yoga, meditação, spinning e outras atividades em grupo, permitindo que cada participante ouça a instrução com clareza, sem caixas de som compartilhadas.',
  },
  {
    q: 'O aluguel de fones imersivos serve para degustações e visitas técnicas?',
    a: 'Sim. É uma solução comum para degustações guiadas (harmonização narrada direto no ouvido) e visitas técnicas em fábricas, obras e instalações, onde o guia narra em tempo real sem precisar gritar.',
  },

];

const cidades = [
  { nome: 'São Paulo', slug: 'sao-paulo' },
  { nome: 'Rio de Janeiro', slug: 'rio-de-janeiro' },
  { nome: 'Brasília', slug: 'brasilia' },
  { nome: 'Belo Horizonte', slug: 'belo-horizonte' },
  { nome: 'Curitiba', slug: 'curitiba' },
  { nome: 'Porto Alegre', slug: 'porto-alegre' },
  { nome: 'Recife', slug: 'recife' },
  { nome: 'Fortaleza', slug: 'fortaleza' },
  { nome: 'Salvador', slug: 'salvador' },
];

function FaqItem({ question, answer, index, isVisible }: { question: string; answer: string; index: number; isVisible: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`border-b border-gray-200 dark:border-gray-700 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      style={{ transitionDelay: `${index * 70}ms` }}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full py-7 px-6 flex items-center justify-between text-left cursor-pointer group hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
      >
        <h3 className="font-heading font-semibold text-lg text-secondary dark:text-white pr-8 group-hover:text-primary transition-colors">
          {question}
        </h3>
        <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-primary flex-shrink-0 transition-all duration-300`}></i>
      </button>
      <div className={`overflow-hidden transition-all duration-400 ${open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="px-6 pb-7">
          <p className="font-body text-base text-gray-700 dark:text-gray-300 leading-relaxed">{answer}</p>
        </div>
      </div>
    </div>
  );
}

export default function AluguelFonesPage() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: equip1Ref, isVisible: equip1Visible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: tipos1Ref, isVisible: tipos1Visible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: faqRef, isVisible: faqVisible } = useScrollAnimation({ threshold: 0.05 });

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://stibpalestrasilenciosasp.com.br';

    document.title = 'Aluguel de Fones Sem Fio para Eventos Brasil | STIB Palestra Silenciosa';

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Aluguel de fones sem fio imersivos para eventos em todo o Brasil: palestra silenciosa, yoga, meditação, spinning, aulas e degustações. +5.000 fones disponíveis. STIB (11) 91777-6227.'
      );
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'aluguel fones sem fio eventos, locação fones sem fio, aluguel headphones eventos, palestra silenciosa aluguel, fones wireless eventos, aluguel fones São Paulo, silent conference equipamentos, fones imersivos, locação fones imersivos, fones sem fio para yoga, fones sem fio para meditação, fones sem fio para spinning, fones sem fio para aula, fones sem fio para experiência imersiva, fones sem fio para degustação, fones sem fio para visita técnica'
      );
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${siteUrl}/aluguel-fones-sem-fio`);

    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          '@id': `${siteUrl}/aluguel-fones-sem-fio#service`,
          name: 'Aluguel de Fones Sem Fio para Eventos',
          alternateName: ['Locação de Fones Sem Fio', 'Aluguel de Headphones para Eventos', 'Silent Conference Equipamentos', 'Aluguel Fones Wireless Eventos Brasil'],
          description:
            'Aluguel de fones de ouvido sem fio profissionais para palestra silenciosa, silent disco, conferência silenciosa e tradução simultânea em todo o Brasil. Inclui transmissores, microfones, montagem e suporte técnico presencial. +5.000 fones disponíveis.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'STIB — Palestra Silenciosa Brasil',
            url: siteUrl,
            telephone: '+55-11-91777-6227',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'São Paulo',
              addressRegion: 'SP',
              addressCountry: 'BR'
            }
          },
          serviceType: 'Locação de Equipamento de Áudio Sem Fio',
          areaServed: [
            { '@type': 'Country', name: 'Brasil' },
            { '@type': 'City', name: 'São Paulo' },
            { '@type': 'City', name: 'Rio de Janeiro' },
            { '@type': 'City', name: 'Brasília' },
            { '@type': 'City', name: 'Belo Horizonte' },
            { '@type': 'City', name: 'Curitiba' },
            { '@type': 'City', name: 'Porto Alegre' },
            { '@type': 'City', name: 'Recife' },
            { '@type': 'City', name: 'Fortaleza' },
            { '@type': 'City', name: 'Salvador' }
          ],
          offers: {
            '@type': 'Offer',
            name: 'Aluguel de Fones Sem Fio — Pacotes',
            description: 'Orçamento personalizado conforme número de fones, tipo de evento e cidade. Atendemos desde 20 fones até eventos com milhares de participantes.',
            availability: 'https://schema.org/InStock',
            areaServed: 'BR',
            priceCurrency: 'BRL',
            priceValidUntil: '2026-12-31',
            url: `${siteUrl}/aluguel-fones-sem-fio`,
            seller: {
              '@type': 'LocalBusiness',
              name: 'STIB — Palestra Silenciosa Brasil',
              telephone: '+55-11-91777-6227'
            }
          },
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Aluguel de Fones Sem Fio', item: `${siteUrl}/aluguel-fones-sem-fio` },
          ],
        },
        {
          '@type': 'FAQPage',
          mainEntity: perguntas.map((p) => ({
            '@type': 'Question',
            name: p.q,
            acceptedAnswer: { '@type': 'Answer', text: p.a },
          })),
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/aluguel-fones-sem-fio#webpage`,
          url: `${siteUrl}/aluguel-fones-sem-fio`,
          name: 'Aluguel de Fones Sem Fio para Eventos Brasil | STIB Palestra Silenciosa',
          description: 'Aluguel de fones sem fio para eventos em todo o Brasil. Palestra silenciosa, silent disco, conferência silenciosa. +5.000 fones disponíveis. Suporte técnico presencial.',
          inLanguage: 'pt-BR',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/aluguel-fones-sem-fio#service` },
          dateModified: new Date().toISOString().split('T')[0]
        }
      ],
    };

    const existingSchema = document.getElementById('aluguel-fones-schema');
    if (existingSchema) existingSchema.remove();
    const script = document.createElement('script');
    script.id = 'aluguel-fones-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('aluguel-fones-schema');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />
      <main>
        {/* Hero */}
        <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden pt-20">
          <div className="absolute inset-0">
            <img
              src="/img/stib/equip-receptores.webp"
              alt="Aluguel de fones sem fio para eventos no Brasil - STIB"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-secondary/85 via-secondary/65 to-secondary/40"></div>
          </div>

          <div
            ref={heroRef}
            className={`relative z-10 max-w-7xl mx-auto px-6 py-20 w-full transition-all duration-700 ${heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm mb-8" aria-label="Breadcrumb">
              <Link to="/" className="text-white/70 hover:text-white transition-colors">Home</Link>
              <i className="ri-arrow-right-s-line text-white/50" aria-hidden="true"></i>
              <span className="text-white font-medium">Aluguel de Fones Sem Fio</span>
            </nav>

            <div className="max-w-3xl">
              <span className="inline-block bg-primary/20 text-primary border border-primary/30 text-sm font-semibold px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider">
                +5.000 fones disponíveis · Brasil todo
              </span>
              <h1 className="font-heading font-extrabold text-5xl md:text-7xl text-white mb-6 leading-tight">
                ALUGUEL DE<br />
                <span className="text-primary">FONES SEM FIO</span><br />
                PARA EVENTOS
              </h1>
              <p className="font-body text-xl text-white/85 leading-relaxed mb-10 max-w-2xl">
                Equipamentos profissionais para <strong className="text-white">palestra silenciosa</strong>, <strong className="text-white">silent disco</strong> e <strong className="text-white">conferência silenciosa</strong> em todo o Brasil. Inclui transmissores, microfones, montagem e suporte técnico presencial.
               Fones sem fio imersivos para yoga, meditação, spinning, aulas, degustações e visitas técnicas.</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contato"
                  className="inline-flex items-center justify-center gap-3 bg-primary text-black px-10 py-4 rounded-full font-body font-bold text-base uppercase hover:bg-opacity-90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-message-3-line text-lg" aria-hidden="true"></i>
                  Solicitar Orçamento Grátis
                </Link>
                <a
                  href="https://wa.me/5511917776227?text=Olá! Preciso de orçamento para aluguel de fones sem fio."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-green-500 text-white px-10 py-4 rounded-full font-body font-bold text-base uppercase hover:bg-green-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
                  (11) 91777-6227
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="bg-secondary dark:bg-gray-800 py-8">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              {[
                { num: '+5.000', label: 'Fones disponíveis' },
                { num: '+500', label: 'Eventos realizados' },
                { num: '9', label: 'Capitais atendidas' },
                { num: '10–12h', label: 'Bateria dos fones' },
              ].map((stat, i) => (
                <div key={i}>
                  <div className="font-heading font-bold text-3xl text-primary mb-1">{stat.num}</div>
                  <div className="font-body text-sm text-white/70">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* O que está incluso */}
        <section className="py-24 bg-gray-50 dark:bg-gray-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <span className="font-body text-primary font-semibold text-sm uppercase tracking-widest mb-3 block">
                Pacote Completo
              </span>
              <h2 className="font-heading font-bold text-5xl md:text-6xl text-secondary dark:text-white mb-4">
                O QUE ESTÁ INCLUSO
              </h2>
              <p className="font-body text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                No <strong>aluguel de fones sem fio</strong> da STIB, você recebe muito mais do que equipamentos. Recebe uma operação completa.
              </p>
            </div>

            <div
              ref={equip1Ref}
              className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
            >
              {equipamentos.map((eq, i) => (
                <div
                  key={i}
                  className={`bg-white dark:bg-gray-900 rounded-2xl p-8 border border-gray-100 dark:border-gray-700 hover:border-primary/40 transition-all duration-500 ${equip1Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                  style={{ transitionDelay: `${i * 120}ms` }}
                >
                  <div className="w-16 h-16 flex items-center justify-center bg-primary/10 dark:bg-primary/20 rounded-2xl mb-6">
                    <i className={`${eq.icon} text-primary text-3xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-secondary dark:text-white mb-3">{eq.nome}</h3>
                  <p className="font-body text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-5">{eq.descricao}</p>
                  <ul className="space-y-2">
                    {eq.specs.map((spec, si) => (
                      <li key={si} className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                        <i className="ri-check-line text-primary flex-shrink-0" aria-hidden="true"></i>
                        <span>{spec}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-primary/5 dark:bg-primary/10 border border-primary/20 rounded-2xl px-8 py-6 flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-primary text-2xl" aria-hidden="true"></i>
              </div>
              <div>
                <p className="font-body font-semibold text-secondary dark:text-white mb-1">Transparência total</p>
                <p className="font-body text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
                  Montagem, desmontagem, suporte técnico presencial, higienização e 10% de fones extras como reserva — tudo incluso no pacote de aluguel. Sem cobranças adicionais surpresa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Para que tipo de evento */}
        <section className="py-24 bg-white dark:bg-gray-900">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <span className="font-body text-primary font-semibold text-sm uppercase tracking-widest mb-3 block">
                Aplicações
              </span>
              <h2 className="font-heading font-bold text-5xl md:text-6xl text-secondary dark:text-white mb-4">
                PARA QUAL EVENTO?
              </h2>
              <p className="font-body text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                O <strong>aluguel de fones sem fio</strong> da STIB atende todos os formatos de evento — do corporativo ao casamento, do congresso ao festival.
               Também atendemos yoga, meditação, spinning, aulas e visitas técnicas com fones sem fio imersivos.</p>
            </div>

            <div
              ref={tipos1Ref}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
            >
              {tiposEvento.map((tipo, i) => (
                <div
                  key={i}
                  className={`bg-gray-50 dark:bg-gray-800 rounded-2xl p-7 hover:bg-white dark:hover:bg-gray-700 border-2 border-transparent hover:border-primary/20 transition-all duration-500 ${tipos1Visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="w-14 h-14 flex items-center justify-center bg-primary/10 dark:bg-primary/20 rounded-xl mb-4">
                    <i className={`${tipo.icon} text-primary text-2xl`} aria-hidden="true"></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-secondary dark:text-white mb-2">{tipo.titulo}</h3>
                  <p className="font-body text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{tipo.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Conteúdo editorial rico para SEO */}
        <section className="py-24 bg-gray-50 dark:bg-gray-800">
          <div className="max-w-4xl mx-auto px-6">
            <article>
              <h2 className="font-heading font-bold text-4xl text-secondary dark:text-white mb-8">
                Por Que Alugar Fones Sem Fio para Eventos?
              </h2>
              <div className="space-y-6 font-body text-gray-700 dark:text-gray-300 text-base leading-relaxed">
                <p>
                  O <strong>aluguel de fones sem fio para eventos</strong> se tornou a alternativa inteligente ao sistema de som convencional por uma razão simples: entrega uma experiência de áudio infinitamente superior para cada participante, ao mesmo tempo em que elimina os problemas clássicos de qualquer evento — reverberação, ruído de fundo, poluição sonora e conflito entre sessões paralelas.
                </p>
                <p>
                  Em uma <strong>palestra silenciosa</strong> ou <strong>conferência silenciosa</strong>, o áudio do palestrante vai diretamente ao ouvido de cada participante via radiofrequência. Não há intermediação de caixas de som. O resultado é um áudio limpo, claro e com volume ajustável individualmente — independentemente de onde o participante está sentado.
                </p>
                <p>
                  Para organizadores de eventos, o <strong>aluguel de fones sem fio</strong> resolve três desafios ao mesmo tempo: elimina a necessidade de salas separadas para sessões paralelas (economizando em locação), elimina cabines de tradução em eventos multilíngues (economizando em infraestrutura) e aumenta o engajamento dos participantes (melhorando os resultados do evento).
                </p>

                <h3 className="font-heading font-bold text-2xl text-secondary dark:text-white pt-4">
                  Quanto Custa o Aluguel de Fones Sem Fio?
                </h3>
                <p>
                  O <strong>aluguel de fones sem fio</strong> é uma solução flexível que se adapta ao porte e às necessidades do seu evento. Para eventos pequenos (20 a 50 fones), médios (50 a 150 fones) ou grandes (150 a 300 fones), temos estrutura dimensionada para cada escala. O custo-benefício é expressivo quando comparado ao modelo tradicional com salas separadas e cabines de tradução.
                </p>
                <p>
                  O importante é comparar o pacote completo: <strong>aluguel de fones sem fio</strong> frequentemente substitui — com vantagem de custo — a combinação de salas extras, sistemas de som convencionais e cabines de tradução. Para um orçamento personalizado, ligue para <a href="tel:+5511917776227" className="text-primary font-semibold hover:underline">(11) 91777-6227</a>.
                </p>

                <h3 className="font-heading font-bold text-2xl text-secondary dark:text-white pt-4">
                  Diferença entre Aluguel de Fones Sem Fio e Palestra Silenciosa
                </h3>
                <p>
                  <strong>Palestra silenciosa</strong> é o formato do evento: o palestrante fala por microfone sem fio e os participantes ouvem via fones. O <strong>aluguel de fones sem fio</strong> é o serviço que viabiliza esse formato — o fornecimento, instalação e suporte dos equipamentos necessários.
                </p>
                <p>
                  A STIB oferece os dois integrados: você não precisa se preocupar com os equipamentos. Nossa equipe cuida de tudo — do planejamento técnico ao recolhimento ao final do evento.
                </p>

                <h3 className="font-heading font-bold text-2xl text-secondary dark:text-white pt-4">
                  Aluguel de Fones Sem Fio em Todo o Brasil
                </h3>
                <p>
                  A STIB é o maior fornecedor de <strong>aluguel de fones sem fio para eventos</strong> do Brasil, com atendimento em São Paulo, Rio de Janeiro, Brasília, Belo Horizonte, Curitiba, Porto Alegre, Recife, Fortaleza, Salvador e demais cidades. Entre em contato para verificar disponibilidade e condições para a sua cidade e data.
                </p>
              </div>
            </article>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-24 bg-white dark:bg-gray-900">
          <div className="max-w-4xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="font-heading font-bold text-5xl text-secondary dark:text-white mb-4">
                PERGUNTAS FREQUENTES
              </h2>
              <p className="font-body text-gray-600 dark:text-gray-300">Sobre aluguel de fones sem fio para eventos</p>
            </div>
            <div ref={faqRef} className="space-y-0">
              {perguntas.map((p, i) => (
                <FaqItem key={i} question={p.q} answer={p.a} index={i} isVisible={faqVisible} />
              ))}
            </div>
          </div>
        </section>

        {/* Cidades */}
        <section className="py-24 bg-gray-50 dark:bg-gray-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-4xl text-secondary dark:text-white mb-3">
                ALUGUEL DE FONES EM TODO O BRASIL
              </h2>
              <p className="font-body text-gray-600 dark:text-gray-300">Atendemos eventos em todas as regiões do país</p>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              {cidades.map((cidade, i) => (
                <Link
                  key={i}
                  to={`/${cidade.slug}`}
                  className="inline-flex items-center gap-2 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 text-secondary dark:text-white px-6 py-3 rounded-full font-body font-medium hover:border-primary hover:text-primary transition-all duration-300 cursor-pointer text-sm"
                >
                  <i className="ri-map-pin-line text-primary" aria-hidden="true"></i>
                  {cidade.nome}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Links internos para blog */}
        <section className="py-20 bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="font-heading font-bold text-3xl text-center text-secondary dark:text-white mb-10">
              Saiba Mais sobre Palestra Silenciosa
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <Link
                to="/blog/palestra-silenciosa-o-que-e-como-funciona-guia-completo"
                className="group flex gap-5 bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 hover:bg-white dark:hover:bg-gray-700 border-2 border-transparent hover:border-primary/20 transition-all duration-300 cursor-pointer"
              >
                <div className="flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden">
                  <img
                    src="/img/stib/fone-plateia-media.webp"
                    alt="Palestra silenciosa: o que é"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-semibold text-primary bg-primary/10 dark:bg-primary/20 px-2 py-1 rounded-full inline-block mb-2">Guia Completo</span>
                  <h3 className="font-heading font-bold text-base text-secondary dark:text-white group-hover:text-primary transition-colors leading-snug">
                    O Que É Palestra Silenciosa e Como Funciona
                  </h3>
                </div>
              </Link>

              <Link
                to="/blog/quanto-custa-palestra-silenciosa-tabela-precos-2026"
                className="group flex gap-5 bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 hover:bg-white dark:hover:bg-gray-700 border-2 border-transparent hover:border-primary/20 transition-all duration-300 cursor-pointer"
              >
                <div className="flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden">
                  <img
                    src="/img/stib/equip-receptores.webp"
                    alt="Quanto custa aluguel de fones sem fio"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-semibold text-primary bg-primary/10 dark:bg-primary/20 px-2 py-1 rounded-full inline-block mb-2">Preços</span>
                  <h3 className="font-heading font-bold text-base text-secondary dark:text-white group-hover:text-primary transition-colors leading-snug">
                    Tabela de Preços 2026: Quanto Custa
                  </h3>
                </div>
              </Link>

              <Link
                to="/blog/locacao-fones-sem-fio-eventos-brasil"
                className="group flex gap-5 bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 hover:bg-white dark:hover:bg-gray-700 border-2 border-transparent hover:border-primary/20 transition-all duration-300 cursor-pointer"
              >
                <div className="flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden">
                  <img
                    src="/img/stib/fone-kit-maleta.webp"
                    alt="Locação de fones sem fio para eventos"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <span className="text-xs font-semibold text-primary bg-primary/10 dark:bg-primary/20 px-2 py-1 rounded-full inline-block mb-2">Guia Prático</span>
                  <h3 className="font-heading font-bold text-base text-secondary dark:text-white group-hover:text-primary transition-colors leading-snug">
                    O Que Avaliar ao Contratar Locação
                  </h3>
                </div>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-24 bg-secondary dark:bg-gray-800">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="font-heading font-bold text-5xl md:text-6xl text-white mb-6">
              Pronto para Alugar Fones Sem Fio?
            </h2>
            <p className="font-body text-xl text-white/85 mb-10 max-w-2xl mx-auto leading-relaxed">
              Solicite um orçamento gratuito. Atendemos todo o Brasil com suporte técnico especializado do início ao fim do evento.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contato"
                className="inline-flex items-center justify-center gap-3 bg-primary text-black px-10 py-5 rounded-full font-body font-bold text-lg uppercase hover:bg-opacity-90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-check-line text-xl" aria-hidden="true"></i>
                Solicitar Orçamento Grátis
              </Link>
              <a
                href="tel:+5511917776227"
                className="inline-flex items-center justify-center gap-3 border-2 border-white text-white px-10 py-5 rounded-full font-body font-bold text-lg uppercase hover:bg-white hover:text-secondary transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl" aria-hidden="true"></i>
                (11) 91777-6227
              </a>
            </div>
          </div>
        </section>
      <NossosFones />
      <PacotesBox texto="Se você usa fones sem fio com frequência, o pacote mensal ou o pacote de eventos sai mais barato do que alugar a cada evento: valor fechado, orçamento previsível e equipamento garantido nas suas datas." />
      </main>
      <Footer />
    </div>
  );
}